import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { setAlertError, setAlertSuccess } from '../alert/alert.slice';
import { reportService } from './report.service';

const initialState = {
  loading: false,
  inceptionDate: null
};

export const getInceptionDate = createAsyncThunk(
  'report/getInceptionDate',
  async (type, thunkAPI) => {
    try {
      const response = await reportService.getInceptionDate(type);
      return response.data?.inceptionDate || null;
    } catch (error) {
      const err = error.response?.data || error.message;
      thunkAPI.dispatch(setAlertError(err));
      throw error;
    }
  }
);

export const getReport = createAsyncThunk('report/getReport', async (data, thunkAPI) => {
  try {
    const response = await reportService.queueDateRangeJob(data);

    thunkAPI.dispatch(setAlertSuccess(response.data.message));

    return response.data;
  } catch (error) {
    const err = error.response?.data || error.message;
    thunkAPI.dispatch(setAlertError(err));
    throw error;
  }
});

export const getProgressReport = createAsyncThunk(
  'report/getProgressReport',
  async (data, thunkAPI) => {
    try {
      const response = await reportService.queueProgressJob(data);

      thunkAPI.dispatch(
        setAlertSuccess(response.data.message || 'Report has been queued successfully.')
      );

      return response.data;
    } catch (error) {
      const err = error.response?.data || error.message;
      thunkAPI.dispatch(setAlertError(err));
      throw error;
    }
  }
);

export const reportSlice = createSlice({
  name: 'report',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(getReport.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(getReport.rejected, (state) => {
        state.loading = false;
      })
      .addCase(getProgressReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProgressReport.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(getProgressReport.rejected, (state) => {
        state.loading = false;
      })
      .addCase(getInceptionDate.fulfilled, (state, action) => {
        state.inceptionDate = action.payload;
      });
  }
});

export default reportSlice.reducer;
